import { render } from "./Products.vue?vue&type=template&id=7622b011&scoped=true"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"

import "./Products.vue?vue&type=style&index=0&id=7622b011&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7622b011"]])

export default __exports__